import { createContext } from 'react'

import { InjectedIntl, InjectedIntlProps, injectIntl } from 'react-intl'

interface IInternationalizationContext {
  intl: InjectedIntl
}

export const InternationalizationContext = createContext({} as IInternationalizationContext)

type InternationalizationProviderProps = { children: React.ReactNode } & InjectedIntlProps

const InternationalizationProvider: React.FC<InternationalizationProviderProps> = ({
  children,
  intl,
}) => {
  return (
    <InternationalizationContext.Provider value={{ intl }}>
      {children}
    </InternationalizationContext.Provider>
  )
}

export default injectIntl(InternationalizationProvider)
